import { type ReactNode } from 'react';
import { BODY, Subsection } from './rules-typography';

type PaceRow = { goal: string; perCreator: string; rate: string };

const PACE_ROWS: PaceRow[] = [
  { goal: '33 creadores', perCreator: '7,27 min', rate: '1 cada ~7 min' },
  { goal: '66 creadores', perCreator: '3,64 min', rate: '1 cada ~3 min 40s' },
  { goal: '99 creadores', perCreator: '2,42 min', rate: '1 cada ~2 min 25s' },
];

function Row({ r }: { r: PaceRow }): ReactNode {
  return (
    <tr className="border-b border-white/[0.04] last:border-b-0">
      <td className="py-1.5">{r.goal}</td>
      <td className="py-1.5">{r.perCreator}</td>
      <td className="py-1.5">{r.rate}</td>
    </tr>
  );
}

export function PaceTable(): ReactNode {
  return (
    <Subsection title="Ritmo de trabajo (4h/día)">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-white/[0.06] text-text-tertiary">
            <th className="py-1.5 font-medium">Objetivo</th>
            <th className="py-1.5 font-medium">Por creador</th>
            <th className="py-1.5 font-medium">Ritmo</th>
          </tr>
        </thead>
        <tbody className={BODY}>
          {PACE_ROWS.map((r) => (
            <Row key={r.goal} r={r} />
          ))}
        </tbody>
      </table>
    </Subsection>
  );
}
